module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-sengkang/key-1-2020.svg?v=7ef868b6";